<template>
  <div>
    <px-view-header title="Cadastro de alçadas" title-class="font-weight-bold"
                    :breadcrumbs="breadcrumbs">
      <template v-slot:before>
        <v-btn class="mb-4 mr-1" icon x-large color="primary"
               @click="onClickBack">
          <v-icon>
            mdi-arrow-left
          </v-icon>
        </v-btn>
      </template>
    </px-view-header>
    <div v-if="loading">
      <px-circular-loading/>
    </div>
    <v-form v-else>
      <v-container class="mb-4">
        <v-row>
          <v-col cols="12">
            <px-autocomplete-comprador
              dense
              required
              class="required rounded-tag-small"
              :error="$v.configuracao.comprador.$error"
              @blur="$v.configuracao.comprador.$touch()"
              v-model="configuracao.comprador"/>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-switch dense
                      class="pa-0 mt-2 mr-2"
                      label="Requer aprovação de todos os responsáveis"
                      color="primary"
                      v-model="configuracao.requerAprovacaoTotal"/>
          </v-col>
        </v-row>
        <v-row class="ml-5" v-for="(alcada, index) in configuracao.alcadas" :key="alcada.$$hash">
          <v-col cols="12" sm="4">
            <px-input-money
              dense
              required
              label="Valor para aprovação"
              class="required rounded-tag-small"
              :error="$v.configuracao.alcadas.$each[index].valor.$error"
              @blur="$v.configuracao.alcadas.$each[index].valor.$touch()"
              v-model="alcada.valor"/>
          </v-col>
          <v-col cols="12" sm="8">
            <px-autocomplete-user-comprador-multiple
              dense
              outlined
              autocomplete="off"
              class="required rounded-tag-small"
              v-model="alcada.responsaveis"
              :error="$v.configuracao.alcadas.$each[index].responsaveis.$error"
              @blur="$v.configuracao.alcadas.$each[index].responsaveis.$touch()">
              <template v-slot:append-outer>
                <v-btn icon @click="onRemoveAlcada(index)">
                  <v-icon>
                    mdi-close
                  </v-icon>
                </v-btn>
              </template>
            </px-autocomplete-user-comprador-multiple>
          </v-col>
        </v-row>
        <v-row class="ml-5">
          <v-col cols="12" class="text-right">
            <v-btn color="primary" small
                   class="rounded-tag-small normal-btn-text elevation-0"
                   @click="onAddAlcada">
              <v-icon small>mdi-plus</v-icon>
              Alçada
            </v-btn>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-btn color="primary"
                   class="rounded-tag-small normal-btn-text elevation-0"
                   :disabled="$v.$invalid"
                   :loading="loadingSave"
                   @click="onClickSave">
              Salvar
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-form>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import ConfiguracaoAprovacaoService
  from '@/modules/configuracao-aprovacao/configuracao-aprovacao-service';
import { NumberUtils } from 'px-components';
import { uniqueId } from 'lodash';

const initialStateAlcada = () => ({
  responsaveis: [],
  valor: 0,
  $$hash: new Date().getTime(),
});

export default {
  data() {
    return {
      id: this.$route.params.id,
      configuracao: {
        comprador: null,
        alcadas: [initialStateAlcada()],
        requerAprovacaoTotal: false,
      },
      loading: false,
      loadingSave: false,
      breadcrumbs: [
        { text: 'Configurações' },
        { text: 'Alçadas', to: '/configuracoes-aprovacao' },
        { text: 'Cadastro de alçadas' },
      ],
    };
  },
  methods: {
    onClickBack() {
      this.$router.push({ name: 'main.configuracoes-aprovacao' });
    },
    onAddAlcada() {
      this.configuracao.alcadas.push(initialStateAlcada());
    },
    onRemoveAlcada(index) {
      if (this.configuracao.alcadas.length <= 1) {
        return;
      }
      this.configuracao.alcadas.splice(index, 1);
    },
    buildPayload() {
      return {
        ...this.configuracao,
        alcadas: this.configuracao.alcadas.map(alcada => ({
          responsaveis: alcada.responsaveis,
          valor: alcada.valor,
        })),
      };
    },
    save() {
      if (this.id) {
        return ConfiguracaoAprovacaoService.update(this.id, this.buildPayload());
      }
      return ConfiguracaoAprovacaoService.create(this.buildPayload());
    },
    onClickSave() {
      this.loadingSave = true;
      this.save()
        .then(() => {
          this.$toast('Configuração criada', { color: 'success' });
          this.onClickBack();
        })
        .finally(() => {
          this.loadingSave = false;
        });
    },
    getConfiguracao() {
      this.loading = true;
      ConfiguracaoAprovacaoService.get(this.id)
        .then(({ data }) => {
          this.configuracao = data;
          this.configuracao.alcadas = this.configuracao.alcadas.map(alcada => ({
            ...alcada,
            valor: NumberUtils.fixNumberInput(alcada.valor),
            $$hash: uniqueId(),
          }));
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  created() {
    if (this.id) {
      this.getConfiguracao();
    }
  },
  validations: {
    configuracao: {
      comprador: {
        required,
      },
      alcadas: {
        $each: {
          responsaveis: {
            required,
          },
          valor: {
            required,
          },
        },
      },
    },
  },
};
</script>
